import api from "./axios";

// Одноразовые ссылки на веб-прохождение unified-теста (/api/v3/test-links)
export type LinkStatus = "pending" | "in_progress" | "completed" | "revoked" | "expired";
export type AttemptStatus = "in_progress" | "completed" | "interrupted";

export interface TestLinkAttempt {
  scan_id: string;
  started_at: string | null;
  status: AttemptStatus;
  blocks_uploaded: ("animals" | "park" | "story")[];
  mst_uploaded: boolean;
}

export interface TestLink {
  token: string;
  url: string;
  mode: "remote" | "supervised";
  status: LinkStatus;
  created_at: string | null;
  expires_at: string | null;
  completed_at: string | null;
  created_by_email: string | null;
  created_by_name: string | null;
  attempts: TestLinkAttempt[];
}

export async function createTestLink(patientId: string, mode: "remote" | "supervised"): Promise<TestLink> {
  const res = await api.post("/v3/test-links", { patient_id: patientId, mode });
  return res.data;
}

export async function listTestLinks(patientId: string): Promise<TestLink[]> {
  const res = await api.get(`/v3/patients/${patientId}/test-links`);
  return res.data;
}

export async function revokeTestLink(token: string): Promise<TestLink> {
  const res = await api.post(`/v3/test-links/${token}/revoke`);
  return res.data;
}
